import template from "./sw-share.mjs";
import { render } from "lit-html";
import { HeartBank } from "../../../managers/HeartBank";

import { Modal } from "flowbite";
import type { ModalOptions, ModalInterface } from "flowbite";
import type { InstanceOptions } from "flowbite";

import { LANGUAGE, isApple } from "../../global";
import Strings from "../../../models/Strings.json";
const strings: any = Strings;

// to used for now
export class SwShare extends HTMLElement {
    private heartbank = new HeartBank();
    private modal: ModalInterface;

    private share: HTMLElement;
    private page: HTMLParagraphElement;
    private selection: HTMLTextAreaElement;

    private submit: HTMLButtonElement;
    private copy: HTMLButtonElement;
    private paste: HTMLButtonElement;
    private clear: HTMLButtonElement;
    private copyAll: HTMLButtonElement;

    private subtitle = "";
    private text = "";
    private url = "";
    private files: File[] = [];

    constructor() {
        super();
        render(template(null), this);

        this.share = this.querySelector("#sw-share")!;
        this.page = this.querySelector("#sw-share-page")!;
        this.selection = this.querySelector("#sw-share-selection")!;

        this.submit = this.querySelector("#sw-share-submit")!;
        this.copy = this.querySelector("#sw-share-copy")!;
        this.paste = this.querySelector("#sw-share-paste")!;
        this.clear = this.querySelector("#sw-share-clear")!;
        this.copyAll = this.querySelector("#sw-share-copy-all")!;

        const modalOptions: ModalOptions = {
            placement: "center",
            backdrop: "dynamic",
            backdropClasses:
                "bg-gray-900/50 dark:bg-gray-900/80 fixed inset-0 z-40",
            closable: true,
            onHide: () => {
                //window.location.hash = "#";
            },
            onShow: () => {
                this.share.style.zIndex = "70";
                //console.log("modal is shown");
            },
            onToggle: () => {
                //console.log("modal has been toggled");
            }
        };

        // instance options object
        const instanceOptions: InstanceOptions = {
            id: "sw-share",
            override: true
        };

        this.modal = new Modal(this.share, modalOptions, instanceOptions);
    }

    connectedCallback() {
        this.submit.addEventListener("click", async () => {
            this.shares(
                this.subtitle,
                this.selection.value.trim()
                    ? this.selection.value.trim() + (isApple ? "" : "\n")
                    : "",
                this.url,
                [] // this.file ? [this.file] : []
            );
        });

        this.copyAll.addEventListener("click", async () => {
            await navigator.clipboard.writeText(this.text);
            alert(strings.select2[LANGUAGE]);
        });

        this.copy.addEventListener("click", async () => {
            const text = this.selection.value.trim()
                ? this.selection.value.trim() + "\n\n" + this.url
                : this.url;
            await navigator.clipboard.writeText(text); // cannot do link first bc werid bug
            alert(strings.select2[LANGUAGE]);
        });

        this.paste.addEventListener("click", async () => {
            if (confirm(strings.select7[LANGUAGE]))
                this.selection.value = await navigator.clipboard.readText();
        });

        this.clear.addEventListener("click", () => {
            if (confirm(strings.select6[LANGUAGE])) this.selection.value = "";
        });
    }

    show(title: string, text: string, url: string, files: File[]) {
        this.subtitle = title;
        this.text = title + "\n\n" + text.replace("<hr>", "");
        this.page.innerHTML =
            title + "<br><br>" + text.replaceAll("\n", "<br>");
        this.url = url;
        this.files = files;
        this.modal.show();
    }

    hide() {
        this.modal.hide();
    }

    private async shares(
        title: string,
        text: string,
        url: string,
        files: File[]
    ): Promise<void> {
        const shareData = {
            title,
            text,
            url,
            files: isApple ? files : [] // for andoid, show file but won't show text or url
        };

        if (navigator.canShare && navigator.canShare(shareData)) {
            try {
                await navigator.share(shareData);
                console.log("Data shared successfully");
            } catch (error: any) {
                if (
                    error.name === "AbortError" ||
                    error.name === "InvalidStateError"
                ) {
                    console.warn("Sharing was cancelled: ", error);
                } else {
                    console.error("Error sharing files: ", error);
                    alert(strings.shareError[LANGUAGE]);
                }
            }
        } else alert(strings.shareError[LANGUAGE]);
    }
}
